<template>
  <div class="jump-warphd nav-bar-fixed">
    <van-nav-bar title="审批列表" left-arrow fixed @click-left="back" />
    <van-tabs v-model="tabActive" class="appr-tabs" @click="change">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="100">
        <van-tab title="待我审批" name="wait">
          <van-search
            class="appr-search"
            v-model="waitValue"
            show-action
            placeholder="申请人/牧场名称/订单编号"
            @clear="onCancel"
          >
            <van-button slot="action" @click="search" size="small" type="info">搜索</van-button>
          </van-search>
          <div class="appr-body">
            <div
              class="appr-item"
              v-for="(item, index) in orderlist"
              @click="nextpage(index, item.id, item)"
            >
              <van-row class="appr-item-head">
                <van-col span="12" class="appr-item-head-hd">
                  <!--<span>{{item.id}}</span>-->
                  <p>{{item.mcmc==null?item.appUserName:item.mcmc==''?item.appUserName:item.mcmc}}</p>
                </van-col>
                <van-col span="12">
                  <p class="item-r">{{item.submitTime}}</p>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="24">
                  <a>
                    <p>
                      <span>订单编号:</span>
                      <!-- <p v-if="item.is_part_out==1">{{item.order_number}}</p>
                      <p v-else>{{item.order_number}}</p> -->
                      <span v-if="item.is_part_out==1" style="color: red">{{item.order_number}}<a v-if="item.reservedOrderFlag>0" class="yuSale">{{item.reservedOrderFlag==2?'预售(Y)':'预售(N)'}}
                        </a>
                        </span>
                      <span v-else>{{item.order_number}}<a v-if="item.reservedOrderFlag>0" class="yuSale">{{item.reservedOrderFlag==2?'预售(Y)':'预售(N)'}}
                        </a></span>
                    </p>
                    <!--<p><span>牧场编号:</span>{{item.mcId}}</p>-->
                    <p>
                      <span>审批类型:</span>
                      {{item.workFlow_type_name}}
                    </p>
                    <p v-if="item.workFlow_type==10">
                      <span>是否配车:</span>
                      {{item.hasSupplyCar}}
                    </p>
                    <!-- 采购单状态 -->
                    <p v-if="item.purOrderStatus!=''">
                      <span>采购单订单状态:</span>
                      {{item.purOrderStatus=='createPurOSucess'?'已创建(请耐心等待SRM处理)':item.purOrderStatus}}
                    </p>
                  </a>
                </van-col>
              </van-row>
              <van-row class="appr-item-foot">
                <van-col span="12">
                  <p>
                    <span>停滞时间:</span>
                    {{item.dead_time}}
                  </p>
                </van-col>
                <van-col span="12">
                  <p class="item-r">
                    <span>申请人:</span>
                    {{item.appUserName}}
                  </p>
                </van-col>
              </van-row>
            </div>
          </div>
        </van-tab>

        <van-tab title="已审批" name="already">
          <van-search
            class="appr-search"
            v-model="alreadyValue"
            show-action
            placeholder="申请人/牧场名称/订单编号"
             @clear="onCancel2"
          >
            <van-button slot="action" @click="searcha" size="small" type="info">搜索</van-button>
          </van-search>
          <div class="appr-body">
            <div class="appr-item" v-for="(item, index) in orderAlreadylist">
              <div @click="nextpage(index, item.workFlow_id, item)">
                <van-row class="appr-item-head">
                  <van-col span="12" class="appr-item-head-hd">
                    <!--<span>{{item.id}}</span>-->
                    <p>{{item.mcmc==null?item.appUserName:item.mcmc==''?item.appUserName:item.mcmc}}</p>
                  </van-col>
                  <van-col span="12">
                    <p class="item-r">{{item.submitTime}}</p>
                  </van-col>
                </van-row>
                <van-row>
                  <van-col span="24">
                    <a>
                      <p>
                        <span>订单编号:</span>
                        <span v-if="item.is_part_out==1" style="color: red">{{item.order_number}}</span>
                        <span v-else>{{item.order_number}}</span>
                      </p>
                      <!-- <p><span>牧场编号:</span>{{item.mcId}}</p>-->
                      <p>
                        <span>审批类型:</span>
                        {{item.workFlow_type_name}}
                      </p>
                      <p v-if="item.workFlow_type==10">
                        <span>是否配车:</span>
                        {{item.hasSupplyCar}}
                      </p>
                    </a>
                  </van-col>
                </van-row>
                <van-row class="appr-item-foot">
                  <van-col span="12">
                    <!--<p><span>停滞时间:</span>{{item.dead_time}}</p>-->
                  </van-col>
                  <van-col span="12">
                    <p class="item-r">
                      <span>申请人:</span>
                      {{item.appUserName}}
                    </p>
                  </van-col>
                </van-row>
              </div>
              <van-button
                style="right: -70%"
                plain
                size="small"
                type="primary"
                @click="seeIsTrueOrder(item.orderId)"
              >查看确认单</van-button>
            </div>
          </div>
        </van-tab>
      </van-list>
    </van-tabs>
  </div>
</template>
<script>
import $ from "jquery";
import {
  NavBar,
  Cell,
  CellGroup,
  Field,
  Button,
  Row,
  Col,
  Tabs,
  Tab,
  Search,
  List
} from "vant";

export default {
  name: "ApprovalList",
  components: {
    [NavBar.name]: NavBar,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [List.name]: List,
    [Search.name]: Search
  },
  data() {
    return {
      num: 0,
      tabActive: 0,
      nowIndex: "",
      activeName: "wait",
      searchVal: "",
      waitValue: "",
      alreadyValue: "",
      orderlist: [],
      orderAlreadylist: [],
      actionStatus: false,
      loading: false,
      finished: false,
      total: 0,
      url: this.jumuc.userCenter.selForMyapprovalWorkflowPage,
      page: 1,
      scrollCout: 0,
      scrollLenth: 0,
      isInitScro: true,
      searchIng:false
    };
  },
  beforeRouteLeave(to, from, next) {
    // this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    this.scrollLenth =
      document.documentElement.scrollTop || document.body.scrollTop;
    next();
    localStorage.setItem("scrollLenth", this.scrollLenth);
    localStorage.setItem("scrollPage", this.page);
    localStorage.setItem("searchVal", this.searchVal);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例,将值传入oldUrl
      vm.oldUrl = from.path;
    });
  },
  mounted() {
    let that = this;
    localStorage.setItem("approvalData", JSON.stringify(null));
    //  this.$nextTick(()=>{
    //   if(this.oldUrl=='/staff/approval/detail/'){
    //      this.waitValue=localStorage.getItem('searchVal');
    //      this.orderAlreadylist=[];
    //      this.onLoad();
    //   }
    // })
  },

  methods: {
    intiscroll() {
      let that = this;
      if (that.scrollCout == 0) {
        let lenthscro = localStorage.getItem("scrollLenth");
        window.scroll(0, lenthscro);
        that.scrollCout = 1;
      }
    },
    back() {
      //history.go(-1);
      this.$router.push({ path: "/usercent" });
    },
    onLoad() {
      let that = this;
      let pageSize = 10;
      if (that.isInitScro) {
        that.isInitScro = false;
        let lenthscro = localStorage.getItem("scrollLenth");
        let scrollPage = localStorage.getItem("scrollPage");
        if (this.oldUrl == "/usercent") {
          this.waitValue = "";
          this.tabActive = "";
        } else {
          this.tabActive =
            localStorage.getItem("actionStatus") == "false" ? 0 : 1;
          if (localStorage.getItem("actionStatus") == "false") {
            //待审批
            this.waitValue = localStorage.getItem("searchVal");
            this.searchVal = that.waitValue;
            this.actionStatus = false;
          } else {
            this.alreadyValue = localStorage.getItem("searchVal");
            this.searchVal = that.alreadyValue;
            that.url = that.jumuc.userCenter.selAuditedListPage;
            this.actionStatus = true;
          }
        }
        if (lenthscro != null) {
          if (lenthscro != "0") {
            pageSize = 10 * scrollPage;
          }
        }
      }
      if(  !this.searchIng){
            // 异步更新数据
      that.$api.post(
        that.url,
        {
          currentPage: that.page,
          pageSize: pageSize,
          orderId: this.searchVal
        },
        successRes => {
          let orderlist = successRes.data.list;
          for (let i = 0; i < orderlist.length; i++) {
            that.orderlist.push(orderlist[i]);
            that.orderAlreadylist.push(orderlist[i]);
          }

          setTimeout(that.intiscroll, 1000);
          if (that.isInitScro) {
            that.page = parseInt(localStorage.getItem("scrollPage")) + 1;
          } else {
            if (successRes.data.pageSize != 10) {
              that.page = successRes.data.pageSize / 10 + 1;
            } else {
              that.page = successRes.data.pageNum + 1;
            }
          }
          that.total = successRes.data.total;
          // 加载状态结束
          that.loading = false;
          // 数据全部加载完成
          if (that.orderlist.length >= that.total) {
            that.finished = true;
          }
        }
      );
      }
     
    },
    change(index, title) {
      let that = this;
      //清空缓存数据
      localStorage.setItem("goodRule", JSON.stringify([])); //商品同步规则
      localStorage.setItem("goodgys", JSON.stringify([])); //商品供应商
      localStorage.setItem("approvalListSycn", 0);
         this.searchVal='';
      if (title == "待我审批") {
        that.actionStatus = false;
        that.search();
      } else {
        that.actionStatus = true;
        that.searcha();
      }
    },
    onCancel (){//待审批错号
      this.waitValue='';
      this.search();
    },
    onCancel2 (){//已审批错号
      this.alreadyValue='';
      this.searcha();
    },
    search() {
      this.searchIng=true;
      let that = this;
       this.searchIng=true;
      that.orderlist = [];
      that.orderAlreadylist = [];
      that.loading = false;
      that.finished = false;
      that.page = 1;
      let seach = "";
      that.url = that.jumuc.userCenter.selForMyapprovalWorkflowPage;
      seach = that.waitValue;
      this.searchVal = that.waitValue;
      this.$api.post(
        that.url,
        { currentPage: that.page, pageSize: 10, orderId: seach },
        successRes => {
           that.total = successRes.data.total;
          that.orderlist = successRes.data.list;
            that.total = successRes.data.total;
          that.page = parseInt(localStorage.getItem("scrollPage")) + 1;
          // 数据全部加载完成
           that.loading = false;
          if (that.orderlist.length >= that.total) {
            that.finished = true;
          }
        }
      );
    },
    searcha() {
      this.searchIng=true;
      let that = this;
      this.searchIng=true;
      that.orderlist = [];
      that.orderAlreadylist = [];
      that.loading = false;
      that.finished = false;
      that.page = 1;
      let seach = "";
      that.url = that.jumuc.userCenter.selAuditedListPage;
      seach = that.alreadyValue;
      this.searchVal = that.alreadyValue;
      this.$api.post(
        that.url,
        { currentPage: that.page, pageSize: 10, orderId: seach },
        successRes => {
           that.total = successRes.data.total;
          that.orderAlreadylist = successRes.data.list;
            that.total = successRes.data.total;
          that.page = parseInt(localStorage.getItem("scrollPage")) + 1;
          // 数据全部加载完成
           that.loading = false;
          if (that.orderAlreadylist.length >= that.total) {
            that.finished = true;
          }
        }
      );
    },
    //点击进入详情
    nextpage(index, workflowId, obj) {
      this.nowIndex = index;
      //console.log(index)
      //this.orderAlreadylist.splice(index,1)
      localStorage.setItem("workflow_id", workflowId);
      localStorage.setItem("curdata", JSON.stringify(obj));
      localStorage.setItem("curdataAlready", JSON.stringify(obj));
      localStorage.setItem("actionStatus", this.actionStatus);
      let workflowType = obj.workFlow_type;
      if (workflowType == 1) {
        this.$router.push({ path: "/staff/approval/type/" });
      } else if (workflowType == 7) {
        this.$router.push({ path: "/staff/approval/milk" });
      } else if (workflowType == 8) {
        this.$router.push({ path: "/staff/approval/offlinePay" });
      }else{
                    if(this.actionStatus){//已审批
                         this.$router.push({path: '/staff/approval/detail/'})
                    }else{
                        if(obj.flowEngineFlag==1){//新流程   
                           this.$router.push({path: '/approval'})
                        }else{//旧流程
                          this.$router.push({path: '/staff/approval/detail/'})
                          
                        }
                  } 
                }
    },
    seeIsTrueOrder(id) {
      let that = this;
      that.$router.push({
        path: "/user/order/arrival",
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style lang="less">
@bule-thame: #3c6eeb;
body {
  background: #f7f7ff;
}

#app .van-tabs__line {
  height: 45px;
  background-color: rgba(255, 255, 255, 0.1);
}

.appr-tabs {
  .van-tab {
    color: #fff;
  }
  .van-tabs__nav {
    background-color: @bule-thame;
  }
  .van-hairline--top-bottom::after {
    border-width: 0;
  }
}

.jump-warphd {
  .appr-search {
    margin-bottom: 10px;
    .van-cell__value {
      border-bottom: 1px #f7f7f7 solid;
    }
    .van-button {
      background-color: @bule-thame;
      border-color: @bule-thame;
    }
  }
  .appr-body {
    padding: 0 10px;
  }
  .appr-item {
    padding: 10px;
    margin-bottom: 10px;
    background-color: #fff;

    p {
      padding: 4px 0;
      font-size: 14px;
      &.item-r {
        color: #ccc;
        text-align: right;
      }
      span {
        min-width: 60px;
        display: inline-block;
      }
    }
    &-head {
      border-bottom: 1px #f7f7f7 solid;
      &-hd {
        position: relative;
        /*padding-left: 40px;*/
        span {
          position: absolute;
          top: 0;
          left: -15px;
          padding: 0 8px;
          color: #fff;
          background-color: @bule-thame;
          font-size: 14px;
          border-radius: 0 10px 10px 0;
        }
      }
    }
    &-foot {
      border-top: 1px #f7f7f7 solid;
      p {
        color: #ccc;
      }
    }
  }
}
.yuSale{
margin-left:10px;color:red!important;
}

</style>
